import axios from 'axios';

const lostlove_api = axios.create({
   baseURL: 'https://api.sherlockk.kurukshetraceg.org.in',
   // baseURL: 'http://localhost:7000',
});

export default lostlove_api;
